const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

async function postData(url = "", data) {
  const response = await fetch(url, {
    method: "POST",
    body: data,
  });
  return response;
}

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("returnForm");
  const email = form.querySelector(`[id^="email"]`);
  const submit = form.querySelector('button[type="submit"]');

  email.addEventListener("keyup", function () {
    if (this.value.match(emailRegex)) {
      this.parentNode.classList.remove("danger");
      submit.removeAttribute("disabled", "");
    } else {
      this.parentNode.classList.add("danger");
      submit.setAttribute("disabled", "");
    }
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const dataEntries = Object.fromEntries(formData);
    const data = new FormData();
    const that = this;

    for (const [name, value] of Object.entries(dataEntries)) {
      data.append(name, value);
    }

    submit.querySelector("span").style.display = "none";
    submit.querySelector("svg").style.display = "block";

    postData(
      //"https://api.cabinpanda.com/form/submit/backendless/4fc056903a5c0d529e809df6843fe78e", // old form
      "https://api.cabinpanda.com/form/submit/backendless/5af0bc7f68b1fad38a007655f158683e",
      formData
    ).then(function (response) {
      if (response.status === 200) {
        document.getElementById("formResponse").style.display = "block";
        var coordinates = document
          .getElementById("formResponse")
          .getBoundingClientRect();
        window.scrollTo({
          top: coordinates.top,
          left: 0,
          behavior: "smooth",
        });
        submit.querySelector("span").style.display = "block";
        submit.querySelector("svg").style.display = "none";
      }
    });
  });
});
